module.exports = __webpack_public_path__ + "img/logo_creditall_inverso.7fe1e13c.png";